import { isFunction, partial } from 'underscore'
import Backbone from '@polleverywhere/backbone'

const retryFn = function (fn, times) {
  let retry = 0
  let timeout = 2000

  return new Promise((resolve, reject) => {
    const tryRequest = () =>
      fn()
        .then(resolve)
        .fail(function (xhr, status, error) {
          // Code 0 or undefined
          if (!xhr.status && (retry <= times)) {
            retry += 1

            setTimeout(tryRequest, timeout)

            timeout = timeout * 2
          } else {
            // Don't log not found or forbidden errors
            if (![404, 403].includes(xhr.status)) {
              window?.Rollbar?.warning('Ajax failed after retries', {
                url: xhr.url,
                retries: retry,
                retryLimit: times,
                status: xhr.status
              })
            }

            reject(xhr, status, error)
          }
        })

    tryRequest()
  })
}

/*
  * Auto retry the specific number of times when the request returns
  * with 0 status. First restart starts at 2s, then doubles each time after that.
  *
  * If this is successful at removing some rollbars, then I'll
  * move it into util or into core
  *
  * @param [Object|Fn] data jQuery ajax data or Function that returns a jqXhr
  * @param [Number] times Retries to attempt
  *
  */
export function ajaxWithRetry (data, times = 1) {
  if (isFunction(data)) {
    return retryFn(data, times)
  } else {
    return retryFn(partial(Backbone.ajax, data), times)
  }
}
